/**
 * Nome de exibição de um Client.
 *
 * A entidade não tem coluna `name` — PF usa `firstName`/`lastName` e PJ usa
 * `tradeName`/`companyName`. Ler `client.name` devolve undefined silenciosamente,
 * que é como a coluna "Cliente" do financeiro vinha renderizando "-" para todo
 * lançamento.
 */
export const displayClientName = (client, fallback = "-") => {
  if (!client) return fallback;

  const isCompany =
    client.personType === "PJ" || client.companyName || client.tradeName;

  if (isCompany) {
    return client.tradeName || client.companyName || fallback;
  }

  const person = [client.firstName, client.lastName].filter(Boolean).join(" ");
  return person || client.tradeName || client.companyName || fallback;
};

/** Linha secundária: razão social quando difere do nome fantasia exibido. */
export const displayClientSubtitle = (client) => {
  if (!client) return null;
  if (client.personType !== "PJ") return null;
  if (!client.companyName || !client.tradeName) return null;
  if (client.companyName === client.tradeName) return null;
  return client.companyName;
};

export default displayClientName;
